import React, { useCallback, useMemo } from 'react';
import lookie from 'lookie';
import dayjs from 'dayjs';
import { ALL_PAGES, SELECTED_CUSTOMER_ID } from '@/constant';
import useNav from '@/hooks/useNav';
import defaultAvatarImg from '@/assets/image/default-avatar.png';
import defaultFemaleAvatarImg from '@/assets/image/default-women-avatar.png';
import { ARRIVAL_STATUS_OPTIONS } from '../enumdata';
import cx from './index.module.scss';

interface Props {
  id: number;
  name: string;
  gender: Customer.Gender;
  createTime: number;
  totalOrders: number;
  lastVisitTime: number;
  recentVisit: FilterByRecentVisit;
  avatarUrl: string;
  orderBy: FilterDimension;
  orderBySort: SortOrder | FilterByRecentVisit[];
}

const MemberRecordItem: React.FC<Props> = props => {
  const { name, avatarUrl, id, gender, recentVisit, totalOrders, createTime, orderBy, orderBySort } = props;
  const nav = useNav();

  const handleSelectMember = useCallback(() => {
    lookie.set(SELECTED_CUSTOMER_ID, id);
    nav(ALL_PAGES.MEMBER_RECORD_DETAIL, {
      state: { customerInfo: { ...props, customerId: id }, orderBy, orderBySort },
    });
  }, [id, nav, orderBy, orderBySort, props]);

  const tipText = useMemo(() => {
    if (recentVisit === 'today') {
      return '记得告知会员理疗注意事项哦';
    } else if (recentVisit === 'yesterday') {
      return '可关怀下顾客的恢复情况哦';
    } else if (['fiveDaysAgo', 'sixDaysAgo', 'aWeekAgo']?.includes(recentVisit)) {
      return '可以咨询下顾客下次理疗时间哦';
    } else if (
      ['moreThanAWeek', 'twoWeeksAgo', 'moreThanTwoWeeks', 'aMonthAgo', 'moreThanAMonth']?.includes(recentVisit)
    ) {
      return '和顾客聊聊，再次激活顾客吧';
    } else if (['twoDaysAgo', 'threeDaysAgo', 'fourDaysAgo']?.includes(recentVisit)) {
      return '-';
    }
  }, [recentVisit]);

  return (
    <div className={cx('member-record-item')} onClick={handleSelectMember}>
      <div className={cx('header')}>
        <div className={cx('left')}>
          <img
            src={avatarUrl ? avatarUrl : gender === 'Female' ? defaultFemaleAvatarImg : defaultAvatarImg}
            alt="avatar"
            className={cx('img')}
            onError={e => {
              const target = e.target as HTMLImageElement;
              target.src = defaultAvatarImg;
            }}
          />
        </div>
        <div className={cx('right')}>
          <div className={cx('member-info')}>
            <div className={cx('member-info-text')}>
              <div>{name} </div>
              <div className={cx('line')} />
              <div>下单</div>
              <div className={cx('order-times')}>{totalOrders}</div>
              <div> 次</div>
            </div>
            <div className={cx('create-time-text')}>创建时间：{dayjs(createTime).format('YYYY/MM/DD  HH:mm:ss')}</div>
          </div>
        </div>
      </div>

      <div className={cx('info')}>
        <div className={cx('tip-text')}>{tipText}</div>
        <div className={cx('member-tag', recentVisit)}>
          {ARRIVAL_STATUS_OPTIONS?.find(item => item.value === recentVisit)?.text}
        </div>
      </div>
    </div>
  );
};

export default MemberRecordItem;
